import { render } from "./SanadDetail.vue?vue&type=template&id=d8b263fe"
import script from "./SanadDetail.vue?vue&type=script&lang=js"
export * from "./SanadDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__